module.exports = __webpack_public_path__ + "static/media/icon-client-note.585bd0f0.svg";